<template>
  <div class="register_page">
    <!--Top Background-->
    <div class="top_background">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="title">
              <h4>{{ $t("cvsteps.title") }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Top Background-->
    <!--Cv Steps Page-->

    <!-- <button @click="takeshot()">Take Screenshot</button>
    <h1>Screenshot:</h1>
    <div id="output"></div> -->
    <div class="cv_steps_page">
      <div class="container">
        <div class="register_wizard_form">
          <div class="wizard_title">
            <h4>{{ $t("cvsteps.wizard_title") }}</h4>
            <p>{{ $t("cvsteps.wizard.desc") }}</p>
          </div>
          <!--Progress Bar-->
          <div class="progress_bar">
            <ul>
              <li :class="{ active: step == 1 }">
                <h4>01 {{ $t("cvsteps.wizard.chooseTemplate") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
              <li :class="{ active: step == 2 }">
                <h4>02 {{ $t("cvsteps.wizard.pay") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
              <li :class="{ active: step == 3 || step == 4 }">
                <h4>03 {{ $t("cvsteps.wizard.fillData") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
            </ul>
          </div>
          <!--Progress Bar-->

          <!--Cv Data-->
          <template v-if="step == 4">
            <vue-html2pdf
              :show-layout="false"
              :float-layout="true"
              :enable-download="true"
              :preview-modal="false"
              :paginate-elements-by-height="1400"
              filename="cv"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a4"
              :pdf-margin="10"
              pdf-orientation="portrait"
              pdf-content-width="100%"
              @progress="onProgress($event)"
              ref="html2Pdf"
            >
              <section slot="pdf-content">
                <TemplateTwo
                  :item="cvData"
                  v-if="tempLang == 'ar'"
                ></TemplateTwo>

                <TemplateTwoEn
                  :item="cvData"
                  v-if="tempLang == 'en'"
                ></TemplateTwoEn>
              </section>
            </vue-html2pdf>

            <TemplateTwo :item="cvData" v-if="tempLang == 'ar'"></TemplateTwo>
            <button
              type="button"
              class="main_button button mt-3"
              @click="generatePDF()"
              v-if="tempLang == 'ar'"
            >
              <span>{{ $t("download") }}</span>
            </button>

            <TemplateTwoEn
              :item="cvData"
              v-if="tempLang == 'en'"
            ></TemplateTwoEn>
            <button
              type="button"
              class="main_button button mt-3"
              @click="generatePDF()"
              v-if="tempLang == 'en'"
            >
              <span>{{ $t("download") }}</span>
            </button>

            <!--Both-->
            <vue-html2pdf
              :show-layout="false"
              :float-layout="true"
              :enable-download="true"
              :preview-modal="true"
              :paginate-elements-by-height="1400"
              filename="cv"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a4"
              :pdf-margin="10"
              pdf-orientation="portrait"
              pdf-content-width="800px"
              @progress="onProgress_ar($event)"
              ref="html2Pdf_ar"
            >
              <section slot="pdf-content">
                <TemplateTwo
                  :item="cvData"
                  v-if="tempLang == 'both'"
                ></TemplateTwo>
              </section>
            </vue-html2pdf>
            <vue-html2pdf
              :show-layout="false"
              :float-layout="true"
              :enable-download="true"
              :preview-modal="true"
              :paginate-elements-by-height="1400"
              filename="cv"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a4"
              :pdf-margin="10"
              pdf-orientation="portrait"
              pdf-content-width="800px"
              @progress="onProgress_en($event)"
              ref="html2Pdf_en"
            >
              <section slot="pdf-content">
                <TemplateTwoEn
                  :item="cvData"
                  v-if="tempLang == 'both'"
                ></TemplateTwoEn>
              </section>
            </vue-html2pdf>

            <TemplateTwo :item="cvData" v-if="tempLang == 'both'"></TemplateTwo>
            <button
              type="button"
              class="main_button button mt-3"
              @click="generatePDF_ar()"
              v-if="tempLang == 'both'"
            >
              <span>{{ $t("download") }}</span>
            </button>

            <TemplateTwoEn
              :item="cvData"
              v-if="tempLang == 'both'"
            ></TemplateTwoEn>
            <button
              type="button"
              class="main_button button mt-3"
              @click="generatePDF_en()"
              v-if="tempLang == 'both'"
            >
              <span>{{ $t("download") }}</span>
            </button>
            <router-link
              :to="`/editCv/${tempLang}/${id}`"
              class="main_button button mt-3"
            >
              <span>{{ $t("edit") }}</span>
            </router-link>
          </template>
          <!--Cv Data-->
        </div>
      </div>
    </div>
    <!--Cv Steps Page-->
  </div>
</template>

<script>
import TemplateTwo from "@/components/CvTemplate/TemplateTwo.vue";
import TemplateTwoEn from "@/components/CvTemplate/TemplateTwoEn.vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import VueHtml2pdf from "vue-html2pdf";
import * as moment from "moment/moment";
export default {
  props: ["tempLang", "id"],
  components: {
    TemplateTwo,
    TemplateTwoEn,
    VueHtml2pdf,
  },
  data() {
    return {
      //Progress Step
      // step: 1,
      //Progress Step

      cvData: null,

      //Data
      allData: null,

      //loading
      loading: false,

      //   tempNum: null,
      //   tempPrice: null,
      //   tempLang: null,

      //Show Model
      show: false,
    };
  },
  methods: {
    // Define the function
    // to screenshot the div
    takeshot() {
      let div = document.getElementById("photo");

      html2canvas(div).then(function (canvas) {
        document.getElementById("output").appendChild(canvas);
      });
    },
    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    onProgress_ar(event) {
      console.log(`Processed: ${event} / 100`);
    },
    onProgress_en(event) {
      console.log(`Processed: ${event} / 100`);
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    generatePDF_ar() {
      this.$refs.html2Pdf_ar.generatePdf();
    },
    generatePDF_en() {
      this.$refs.html2Pdf_en.generatePdf();
    },

    //Cv Details
    getCv() {
      this.$axios({
        method: "GET",
        url: "cv_design_details?cv_id=" + this.id,
      }).then((res) => {
        this.cvData = res.data.data;
      });
    },

    //Country Code
    onSelect({ name, iso2, dialCode }) {
      console.log(name, iso2, dialCode);
      this.data.code = dialCode;
    },

    makePDF() {
      window.html2canvas = html2canvas;
      var doc = new jsPDF("p", "pt", "a4");

      doc.html(document.querySelector("#canvas_div_pdf"), {
        callback: function (pdf) {
          pdf.save("mypdf.pdf");
        },
      });
    },
    getPDF() {
      setTimeout(function () {
        var HTML_Width = $(".canvas_div_pdf").width();
        var HTML_Height = $(".canvas_div_pdf").height();
        var top_left_margin = 0;
        // var PDF_Width = HTML_Width + (top_left_margin * 2);
        // var PDF_Height = (PDF_Width * 4.5) + (top_left_margin * 2);
        var PDF_Width = HTML_Width + top_left_margin * 2;
        var PDF_Height = PDF_Width * 4.5 + top_left_margin * 2;
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;
        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
        html2canvas($(".canvas_div_pdf")[0], {
          allowTaint: true,
        }).then(function (canvas) {
          canvas.getContext("2d");
          var imgData = canvas.toDataURL("image/jpeg", 1.0);
          var pdf = new jsPDF("l", "mm", [297, 210]);
          var width = 297;
          var height = 210;
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            top_left_margin,
            width,
            height
          );
          for (var i = 1; i <= totalPDFPages; i++) {
            pdf.addPage(PDF_Width, PDF_Height);
            pdf.addImage(
              imgData,
              "JPG",
              top_left_margin,
              -(PDF_Height * i) + top_left_margin * 4,
              canvas_image_width,
              canvas_image_height
            );
          }
          pdf.save("bill.pdf");
        });
      }, 1000);
    },
    takeshot() {
      let div = document.getElementById("canvas_div_pdf");

      // Use the html2canvas
      // function to take a screenshot
      // and append it
      // to the output div
      html2canvas(div).then(function (canvas) {
        document.getElementById("output").appendChild(canvas);
        var img = canvas.toDataURL("image/png");
        console.log(img);
        window.open(img);
      });
    },
  },
  mounted() {
    this.getCv();
  },
  created() {
    this.$store.dispatch("cv_module/addStep", {
      step: 4,
    });
  },
  computed: {
    step() {
      return this.$store.getters["cv_module/cvStep"];
    },
    cv_id() {
      return this.$store.getters["cv_module/cvId"];
    },
  },
};
</script>

<style>
.skill_item {
  margin-bottom: 15px;
}

.skill_item span {
  font-size: 15px;
  display: flex;
  margin-bottom: 4px;
}

.range {
  width: 400px;
  height: 15px;
  -webkit-appearance: ntwo;
  background: #cecece;
  direction: ltr;
  outline: ntwo;
  border-radius: 0px;
  overflow: hidden;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 1); */
}
.range::-webkit-slider-thumb {
  -webkit-appearance: ntwo;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #0eb6d8;
  cursor: pointer;
  border: 4px solid #fff;
  box-shadow: -407px 0 0 400px #0eb6d8;
}

.vue-country-select {
  margin-bottom: 15px;
  margin-inline-end: 5px;
}
</style>
